import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ClipLoader from "react-spinners/ClipLoader";
import styles from "../NewSpecialModal/NewSpecialModal.module.css";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { toast } from "react-toastify";
import { updateSpecialHour } from "../../../../env/APIManager";
import { useFetch } from "../../../../useFetch";

export default function NewSpecialModal({
	toggleSpecialHours,
	setSpecialHours,
	sortDays,
	hours,
	getHours
}) {
	const [selectedDay, setSelectedDay] = useState(null);
	const [openTime, setOpenTime] = useState("");
	const [closeTime, setCloseTime] = useState("");
	const [closedAllDay, setClosedAllDay] = useState(false);
	const [openAllDay, setOpenAllDay] = useState(false);
	const [disabledBefore, setDisabledBefore] = useState(null);
	const [saveLoading, setSaveLoading] = useState(false);

	const { fetchFuntion } = useFetch();

	const handleSave = async () => {
		if (!selectedDay) {
			toast.error("Please select a date to proceed", {
				position: "top-center",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
			});
			return;
		}

		if (closedAllDay === false && openAllDay === false)
			if (openTime === "" || closeTime === "") {
				toast.error("Please select a time to proceed", {
					position: "top-center",
					autoClose: 5000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",
				});
				return;
			}

		const specialHour = {
			date: selectedDay?.getTime(),
			openTime: openTime,
			closeTime: closeTime,
			closedAllDay: closedAllDay,
			openAllDay: openAllDay,
		};
		setSaveLoading(true);

		let arg = {
			url: updateSpecialHour,
			method: "POST",
			data: {
				specialHour: specialHour,
			},
			auth: true,
		};

		const response = await fetchFuntion(arg);

		if (response?.code === "SUCCESS") {
			setSpecialHours(sortDays(response?.specialHours));
			toast.success("Your changes have been saved", {
				position: "top-center",
				autoClose: 5000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
			});
			clearData();
			setTimeout(() => {
				toggleSpecialHours();
			}, 500);
		}
		setSaveLoading(false);

	};

	const clearData = () => {
		setSelectedDay(null);
		setOpenTime("");
		setCloseTime("");
		setClosedAllDay(false);
		setOpenAllDay(false);
	};

	const handleClosedCheck = (event) => {
		setClosedAllDay(event.target.checked);
		setOpenAllDay(false);
	};

	const handleOpenCheck = (event) => {
		setOpenAllDay(event.target.checked);
		setClosedAllDay(false);
	};

	const closeClick = async () => {
		toggleSpecialHours();
		clearData();
	};

	useEffect(() => {
		setDisabledBefore([{ before: new Date() }]);
	}, []);

	return (
		<>
			<div className={styles.whiteSpace}>
				<div className={styles.container}>
					<div className={styles.navbar}>
						<div className={styles.cancelBtn}>
							<CloseIcon
								onClick={closeClick}
								fontSize="large"
								sx={{ color: "black" }}
							/>
						</div>
						<div className={styles.title}>New Special Hours</div>
					</div>
					<div className={styles.calendarCard}>
						<DayPicker
							mode="single"
							selected={selectedDay}
							onSelect={setSelectedDay}
							numberOfMonths={1}
							disabled={disabledBefore}
							styles={{ root: { "--rdp-background-color": "#F2EDFF" } }}
							modifiersStyles={{ selected: { backgroundColor: "#6C40FC" } }}
						/>
					</div>
					<div className={styles.selectTimeRow}>
						<div className={styles.time}>Time</div>
						{closedAllDay && (
							<div className={styles.selectorSpacer}>Closed All Day</div>
						)}
						{openAllDay && (
							<div className={styles.selectorSpacer}>Open All Day</div>
						)}
						{!closedAllDay && !openAllDay && (
							<div className={styles.timeSelectors}>
								<label
									className={[
										styles.customSelect,
										openTime === "" ? styles.placeholderSelected : "",
									].join(" ")}
								>
									<select
										value={openTime}
										onChange={(event) => setOpenTime(event.target.value)}
									>
										<option value="">Select a Time</option>
										{hours?.map((id, index) => (
											<option key={index} value={id}>
												{getHours(id)}
											</option>
										))}
									</select>
								</label>
								<div style={{ fontSize: "10px" }}>—</div>
								<label
									className={[
										styles.customSelect,
										closeTime === "" ? styles.placeholderSelected : "",
									].join(" ")}
								>
									<select
										value={closeTime}
										onChange={(event) => setCloseTime(event.target.value)}
									>
										<option value="">Select a Time</option>
										{hours
											?.filter((el) => el >= openTime)
											?.map((id, index) => (
												<option key={index} value={id}>
													{getHours(id)}
												</option>
											))}
									</select>
								</label>
							</div>
						)}
						<div id={styles.closeCheck}>
							<label className={styles.customCheckmark}>
								<input
									type="checkbox"
									checked={closedAllDay}
									onChange={(event) => {
										handleClosedCheck(event);
									}}
								/>
								<span className={styles.checkmark}></span>
								<span className={styles.label}>Closed All Day</span>
							</label>
						</div>
						<div id={styles.openCheck}>
							<label className={styles.customCheckmark}>
								<input
									type="checkbox"
									checked={openAllDay}
									onChange={(event) => {
										handleOpenCheck(event);
									}}
								/>
								<span className={styles.checkmark}></span>
								<span className={styles.label}>Open All Day</span>
							</label>
						</div>
					</div>
					<div className={styles.saveBtn} onClick={handleSave}>
						Save
						{saveLoading && (
							<span>
								<ClipLoader color="#FFF" size={30} />
							</span>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
